import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(private httpClient: HttpClient) {
  }

  uploadFile(url, data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(url, data).subscribe((response) => resolve(response), error => reject(error));
    });
  }
}
